import aiBanner from '../components/organisms/AiBanner/AiBanner';
import biographyBlockSection from '../components/organisms/BiographyBlockSection/BiographyBlockSection';
import blockContentSection from '../components/molecules/BlockContentSection/BlockContentSection';
import carouselSection from '../components/organisms/CarouselSection/CarouselSection';
import cccTileSection from '../components/organisms/CCCTileSection/CCCTileSection';
import clientCarouselSection from '../components/organisms/ClientCarouselSection/ClientCarouselSection';
import clientCarouselSectionV1 from '../components/organisms/ClientCarouselSection/ClientCarouselSectionV1';
import clientTileSection from '../components/organisms/ClientTileSection/ClientTileSection';
import customerStatsSection from '../components/organisms/CustomerStatsSection/CustomerStatsSection';
import ctaCardsSection from '../components/organisms/CtaCardsSection/CtaCardsSection';
import form from '../components/molecules/Form/Form';
import formSection from '../components/organisms/FormSection/FormSection';
import gradientCard from '../components/organisms/GradientCard/GradientCard';
import gtmSection from '../components/organisms/GTMSection/GTMSection';
import heroBanner from '../components/organisms/HeroBanner/HeroBanner';
import iconGridSection from '../components/organisms/IconGridSection/IconGridSection';
import iconHeadingSection from '../components/organisms/IconHeadingSection/IconHeadingSection';
import iconTextBlockSection from '../components/organisms/IconTextBlockSection/IconTextBlockSection';
import marketoEmbeddedForm from '../components/molecules/MarketoEmbeddedForm/MarketoEmbeddedForm';
import oneColumnSection from '../components/organisms/OneColumnSection/OneColumnSection';
import productSegmentSection from '../components/organisms/ProductSegmentSection/ProductSegmentSection';
import quoteGradientCard from '../components/organisms/QuoteGradientCard/QuoteGradientCard';
import quoteLogoSlider from '../components/organisms/QuoteLogoSlider/QuoteLogoSlider';
import quoteLogoSliderV1 from '../components/organisms/QuoteLogoSliderV1/QuoteLogoSliderV1';
import radialIconSection from '../components/organisms/RadialIconSection/RadialIconSection';
import slantBanner from '../components/organisms/SlantBanner/SlantBanner';
import smbSlantBanner from '../components/organisms/SmbSlantBanner/SmbSlantBanner';
import statsCounterSection from '../components/organisms/StatsCounterSection/StatsCounterSection';
import suiteCards from '../components/organisms/SuiteCards/SuiteCards';
import suiteBenefitsBanner from '../components/organisms/SuiteBenefitsBanner/SuiteBenefitsBanner';
import suiteIconGridSection from '../components/organisms/SuiteIconGridSection/SuiteIconGridSection';
import tilesSection from '../components/organisms/TilesSection/TilesSection';
import timelineSection from '../components/organisms/TimelineSection/TimelineSection';
import threeCardSection from '../components/organisms/ThreeCardSection/ThreeCardSection';
import twoColumnSection from '../components/organisms/TwoColumnSection/TwoColumnSection';
import twoColumnTextSection from '../components/organisms/TwoColumnTextSection/TwoColumnTextSection';

/* Section names must match the Sanity schema name/type. Refer to Section
    field types in backend/schemas/organisms/templates/allClientsPage.js
   */

export const sectionComponents = {
  aiBanner,
  allClientsSlantBanner: slantBanner,
  biographyBlockSection,
  blockContentSection,
  carouselSection,
  cccTileSection,
  clientCarouselSection,
  clientCarouselSectionV1,
  clientSlantBanner: slantBanner,
  clientTileSection,
  customerStatsSection,
  ctaCardsSection,
  form,
  formSection,
  gradientCard,
  gtmSection,
  heroBanner,
  iconGridSection,
  iconHeadingSection,
  iconTextBlockSection,
  industrySlantBanner: slantBanner,
  marketoEmbeddedForm,
  oneColumnSection,
  productSegmentSection,
  quoteGradientCard,
  quoteLogoSlider,
  quoteLogoSliderV1,
  radialIconSection,
  slantBanner,
  statsCounterSection,
  smbSlantBanner,
  subscriptionSlantBanner: slantBanner,
  suiteBenefitsBanner,
  suiteCards,
  suiteIconGridSection,
  tilesSection,
  threeCardSection,
  timelineSection,
  twoColumnSection,
  twoColumnTextSection,
};

export default {
  sectionComponents,
};
